// Theme preference: 'light' | 'dark' | 'system'. The body gets .dark-mode when the result is dark.
// 'system' follows the OS setting live. Older installs stored darkModeEnabled=true/false; that maps to dark/light.
const KEY = 'theme';
const mq = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

export function readTheme() {
  try {
    const t = localStorage.getItem(KEY);
    if (t === 'light' || t === 'dark' || t === 'system') return t;
    const old = localStorage.getItem('darkModeEnabled');
    if (old === 'true') return 'dark';
    if (old === 'false') return 'light';
  } catch (e) { /* storage blocked */ }
  return 'system';
}

let current = 'system';
export function applyTheme(pref) {
  current = pref;
  const dark = pref === 'dark' || (pref === 'system' && !!(mq && mq.matches));
  document.body.classList.toggle('dark-mode', dark);
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  return dark;
}

export function saveTheme(pref) {
  try { localStorage.setItem(KEY, pref); localStorage.removeItem('darkModeEnabled'); } catch (e) { /* ignore */ }
  return applyTheme(pref);
}

if (mq) {
  const onChange = () => { if (current === 'system') applyTheme('system'); };
  if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
}
